import React from 'react';
//import Config from '../../data/SiteConfig';
export default function index() {

  const outletDetails = JSON.parse(sessionStorage.getItem('user-outletDetails'));
  //console.log(sessionStorage.getItem('user-outletDetails'));
  // console.log(outletDetails.currencySymbol,'currencySymbol');
  return (
    // <span style={{ fontFamily: "Inter", fontSize: "16px", fontWeight: "500" }} >
    //   {/* {outletDetails.address.country === '' ? Config.DefaultCurrencySymbol : outletDetails.address.country.toLowerCase() === 'india' ? Config.DefaultCurrencySymbol : ''} */}
    //   { outletDetails.currencySymbol }
    // </span>
    // Added by vijay on 02-04-2025 - Due to currency symbol is ned to take in API only 
    <span
      style={{ fontFamily: "Inter", fontSize: "16px", fontWeight: "500" }}
      dangerouslySetInnerHTML={{
        __html: outletDetails.currencySymbol === "?" ? "" : outletDetails.currencySymbol,
      }}
    />
  )
}